import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';
import styles from './CarModelCarousel.module.scss';
import Slide from './Slide/Slide';

export default function CarModelCarousel({
  swiperRef,
  newCarouselData,
  setSlideIndex,
  buttonConfig,
}) {
  return (
    <div className={styles.wrapper}>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        slidesPerView={1}
        spaceBetween={0}
        centeredSlides
        modules={[Navigation]}
        onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
      >
        {(newCarouselData || []).map((slide) => (
          <SwiperSlide key={slide.id}>
            <Slide key={slide.id} slide={slide} buttonConfig={buttonConfig} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
